import {useMutation} from "@tanstack/react-query";
import axios from "axios";
import {openIDConnectLoginUrl} from "../../constants/api/endpoints";
import {backendBaseUrl} from "../../constants/api/backendBaseUrl";
import {jsonToJwt} from "../../lib/jwt/jsonToJwt";
import {useAxios} from "../../hooks/axios/useAxios";

export const useOpenIDLogin = () => {
  const axiosSoft = useAxios();

  const postOpenIDLogin = async ({state, code}: { state: string, code: string }) => {
    if (state && code) {
      const response = await axios.post(`${backendBaseUrl}${openIDConnectLoginUrl}`,
        {
          state,
          code
        }, {
          headers: {
            "Authorization": "Bearer " + jsonToJwt({}),
          },
        });
      return response.data;
    }
  };

  const postOpenIDLoginSoft = async ({state, code}: { state: string, code: string }) => {
    if (state && code) {
      const response = await axiosSoft.post(openIDConnectLoginUrl,
        {
          state,
          code
        });
      return response.data;
    }
  };

  return useMutation({
    mutationKey: ['identity_provider_login'],
    mutationFn: localStorage.getItem('refresh') ? postOpenIDLoginSoft : postOpenIDLogin,
    retry: 1,
  });
};